class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener("reset", this.onFormReset.bind(this));
      this.input.addEventListener(
        "input",
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  getCookie(name) {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    return match ? match[2].trim() : null;
  }

  getLuigisboxCustomerId(providedCustomerId = null) {
    const normalizedCustomerId = String(providedCustomerId || "").trim();

    if (!normalizedCustomerId.length) {
      return null;
    }

    if (normalizedCustomerId.startsWith("shopify_id_")) {
      return normalizedCustomerId;
    }

    return `shopify_id_${normalizedCustomerId}`;
  }

  isLuigisboxConsentGranted() {
    const customerPrivacy = window.Shopify?.customerPrivacy;

    if (typeof customerPrivacy?.analyticsProcessingAllowed === "function") {
      return Boolean(customerPrivacy.analyticsProcessingAllowed());
    }

    if (typeof customerPrivacy?.userCanBeTracked === "function") {
      return Boolean(customerPrivacy.userCanBeTracked());
    }

    return Boolean(this.getCookie("_lb"));
  }

  getLuigisboxRequestIdentity(providedCustomerId = null) {
    const customerId = this.getLuigisboxCustomerId(providedCustomerId);
    const clientCookieId = this.isLuigisboxConsentGranted() ? this.getCookie("_lb") : null;

    return {
      userId: customerId || clientCookieId || null,
      clientId: customerId ? clientCookieId || null : undefined,
    };
  }

  applyLuigisboxRequestIdentity(searchParams, providedCustomerId = null) {
    const { userId, clientId } = this.getLuigisboxRequestIdentity(providedCustomerId);

    searchParams.set("user_id", userId || "null");

    if (typeof clientId === "undefined") {
      searchParams.delete("client_id");
      return;
    }

    searchParams.set("client_id", clientId || "null");
  }

  toggleResetButton() {
    if (!this.resetButton) {
      return null;
    }

    const resetIsHidden = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove("hidden");
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add("hidden");
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = "";
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define("search-form", SearchForm);
